/**
 * What refuses turning off an admin switch while requests may still hold its
 * role: the backend's configurer, when the customer submits, and the
 * installer, before it shows the Terraform that takes the role away. One
 * text for both.
 */

/** How the refusal names account admin in an account. */
export const accountAdminRole = (accountId: string) =>
  `account admin in Databricks account ${accountId}`;

/** How the refusal names workspace admin on a workspace. */
export const workspaceAdminRole = ({
  workspaceId,
  workspaceName,
}: {
  workspaceId: string;
  workspaceName: string;
}) =>
  `workspace admin on Databricks workspace ${workspaceName} (${workspaceId})`;

/**
 * Says that P0 still manages `role` for the requests `requestIds`, which
 * must end before the switch can be turned off.
 */
export const renderStillManaged = ({
  role,
  requestIds,
}: {
  role: string;
  requestIds: readonly string[];
}) => {
  const [count, them] =
    requestIds.length === 1
      ? ["1 request", "it"]
      : [`${requestIds.length} requests`, "them"];
  return `P0 still manages ${role} for ${count}: ${requestIds.join(", ")}. Let ${them} end or revoke ${them}, then turn this off.`;
};
